import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChange,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import * as localforage from "localforage";
import {
  InputBoolean,
  NzFormatBeforeDropEvent,
  NzFormatEmitEvent,
} from "ng-zorro-antd/core";
import { NzResizeEvent } from "ng-zorro-antd/resizable";
import { NzTableComponent } from "ng-zorro-antd/table";
import { Observable, of } from "rxjs";
import { delay } from "rxjs/operators";
import { ColWidth } from "../model/colWidth";
import { Page } from "../model/common-type";
import { CommonSessionService } from "../service/common-session.service";
import {
  measureTableColWidth,
  resolveAutoTableScroll,
} from "../utils/hd-table-scroll.util";
import {
  HdTableColumn,
  HdTableTotalOption,
  OperateBtn,
  TableCacheOption,
  TreeGrid,
} from "./hd-table.service";
@Component({
  selector: "hd-table",
  templateUrl: "./hd-table.component.html",
  styleUrls: ["./hd-table.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdTableComponent implements OnInit {
  @Input() uuid: string;
  @Input() tableCols: Array<HdTableColumn> = [];
  @Input() tableData: Page<any>;
  @Input() @InputBoolean() showSelected: boolean = false;
  @Input() @InputBoolean() showOperateColWarpButton: boolean = false;
  @Input() @InputBoolean() virtualScroll: boolean = true;
  /** 手动指定行高；不传则在首屏渲染后自动测量 */
  @Input() virtualItemSize: number;
  @Input() selectField: string = "billNumber";
  /**
   * 行勾选禁用字段名。定义后取当前行该字段：
   * 为 true 时禁用该行勾选（全选也会跳过）。
   */
  @Input() selectDisabledField: string;
  /**
   * 行失效字段名。定义后取当前行该字段：
   * 为 true 时整行背景色为 #F7F8FA。
   */
  @Input() rowInvalidField: string;
  // 合计区域
  @Input() @InputBoolean() showTableTotal: boolean = false;
  @Input() tableTotalOption: Array<HdTableTotalOption>;
  @Output() sortEvent = new EventEmitter();
  @Output() selectEvent = new EventEmitter();
  @Output() tableSearchEvent = new EventEmitter();
  @Input() tableLoading: boolean = false;
  /** 是否显示分页；false 时一次展示 tableData.content 全部行 */
  @Input() @InputBoolean() pagination: boolean = true;
  /**
   * 是否前端分页（对 content 全量切片）。
   * true：翻页不触发 tableSearchEvent，适合详情全量数据；
   * false（默认）：服务端分页，翻页触发查询（现有列表行为）。
   * 与 pagination=false 同时用时以不分页为准。
   */
  @Input() @InputBoolean() frontPagination: boolean = false;
  // 表格分页参数
  @Input() tablePageIndex: number = 1;
  @Input() tablePageSize: number = 100;
  @Input() isFirstEntrySearch: boolean;
  @Input() isCrossPageSelect: boolean;
  @Output() tablePageIndexChange = new EventEmitter<any>();
  @Output() tablePageSizeChange = new EventEmitter<any>();
  @Output() tablePageSizeChangeEvent = new EventEmitter<any>();
  @ContentChild("tableTotal", { static: false }) tableTotal: TemplateRef<any>;
  @ContentChild("tableLeftButton", { static: false })
  tableLeftButton: TemplateRef<any>;
  @ContentChild("tableRightButton", { static: false })
  tableRightButton: TemplateRef<any>;
  scroll = null;

  // 表格勾选参数
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  listOfDisplayData = [];
  listOfAllData = [];
  listOfSelection: Array<any> | TemplateRef<void>;
  mapOfCheckedId: { [key: string]: boolean } = {};
  mapOfCheckList: { [key: string]: any } = {};
  // 合计参数
  tableTotalOptionList = [];
  // 缓存信息
  tableCacheOption: TableCacheOption = new TableCacheOption();
  userSession: any;

  tableColsCache: Array<HdTableColumn> = [];
  showTable: boolean = false;
  selectColListNodes: Array<TreeGrid> = [];
  selectColListNodesCache: Array<TreeGrid> = [];
  showListNodes: boolean = false;

  isDropdownVisible: boolean = false;
  // 设置列的可见操作数组
  nowListNodes: Array<TreeGrid> = [];
  // 设置列的不可见操作数组
  hideListNodes: Array<TreeGrid> = [];

  // 点击时需要有临时数组存放两个tree,用于取消时候恢复调整前的状态
  cancelNowListNodes: Array<TreeGrid> = [];
  cancelHideListNodes: Array<TreeGrid> = [];
  showDetail: boolean = false;
  localforage: any = null;
  localtionTmp: string = "";
  isFirstEntrySearchLocal: boolean = true;
  isCrossPageSelectLocal: boolean = false;

  /** 自动测量前的兜底行高，测量完成后会更新 */
  measuredVirtualItemSize = 47;

  /** 记录当前是否处于虚拟滚动模式，用于切换 pageSize 时重建表格 */
  private virtualScrollActive: boolean | null = null;

  /** 可见列总宽，用于判断是否需要横向滚动 */
  private tableColWidthTotal = 0;

  /** 数据更新后待复位纵向滚动位置 */
  private pendingResetScrollTop = false;

  /** 当前排序，表格重建后用于恢复表头排序态 */
  private currentSortKey: string = null;
  private currentSortValue: string = null;

  @ViewChild("hdTable", { static: false }) nzTableComponent: NzTableComponent;

  constructor(
    private cdr: ChangeDetectorRef,
    private commonSessionService: CommonSessionService,
  ) {
    this.localforage = localforage.createInstance({
      driver: localforage.INDEXEDDB,
      name: "hd-fscm", // 设置存储库的名称
      version: 1.0, // 设置存储库的版本
      storeName: "hd-fscm-store", // 设置存储库的存储空间名称
    });
  }

  ngOnInit(): void {
    if (this.isFirstEntrySearch === false) {
      this.isFirstEntrySearchLocal = this.isFirstEntrySearch;
    }
    if (this.isCrossPageSelect === true) {
      this.isCrossPageSelectLocal = this.isCrossPageSelect;
    }
    this.localtionTmp = location.pathname;
    if (this.localtionTmp) {
      this.localtionTmp = this.localtionTmp.replace(/\//g, "_");
    }
    this.userSession = this.commonSessionService.getSession(
      "__jy_authorization_session__",
    );
    // 用于开发环境调试
    if (!this.userSession) {
      this.userSession = {
        userCode: "dev",
      };
    }

    this.deleteHideItem();
    if (!this.tableCols || this.tableCols.length === 0) {
      return;
    }

    this.localforage
      .ready()
      .then(() => {
        this.getInitLocalforage();
      })
      .catch(function (e) {
        console.log("localforage加载异常step1", e);
        throw "localforage加载异常";
      });
  }

  ngOnChanges(changes: SimpleChange) {
    if (
      changes &&
      changes["tableData"] &&
      changes["tableData"]["currentValue"] &&
      changes["tableData"]["previousValue"]
    ) {
      if (
        changes["tableData"]["currentValue"]["pageSize"] !==
          changes["tableData"]["previousValue"]["pageSize"] ||
        changes["tableData"]["currentValue"]["pageNumber"] !==
          changes["tableData"]["previousValue"]["pageNumber"]
      ) {
        this.pendingResetScrollTop = true;
        if (this.virtualScroll) {
          // 仅虚拟/普通模式真正切换时重建，避免排序后数据刷新把排序态清掉
          this.applyTableScrollMode(false);
        }
        // 翻页/改 pageSize：主动多次复位，覆盖 CDK 异步渲染时序
        this.scheduleResetTableBodyScrollTop();
        return;
      }
      if (!this.isCrossPageSelectLocal) {
        this.resetStatus();
      }
    }

    if (changes["tableData"]) {
      this.pendingResetScrollTop = true;
      if (this.virtualScroll) {
        // 数据刷新不强制重建，只在滚动模式变化时 remount
        this.applyTableScrollMode(false);
      }
      // 数据更新后复位纵向滚动（含虚拟滚动场景）
      this.scheduleResetTableBodyScrollTop();
    }

    if (
      changes["tableCols"] &&
      JSON.stringify(changes["tableCols"].currentValue) !==
        JSON.stringify(changes["tableCols"].previousValue) &&
      changes["tableCols"].previousValue !== undefined
    ) {
      this.deleteHideItem();
      if (!this.tableCols || this.tableCols.length === 0) {
        return;
      }
      this.localforage
        .ready()
        .then(() => {
          this.getInitLocalforage();
        })
        .catch(function (e) {
          console.log("localforage加载异常step2", e);
          throw "localforage加载异常";
        });
    }

    if (
      (changes["pagination"] && !changes["pagination"].firstChange) ||
      (changes["frontPagination"] && !changes["frontPagination"].firstChange)
    ) {
      // 分页模式切换需重建 nz-table（front / server / none）
      this.tablePageIndex = 1;
      this.applyTableScrollMode(true);
      this.cdr.markForCheck();
    }
  }

  /** 是否走前端分页（对 content 切片，不请求后端） */
  get useFrontPagination(): boolean {
    return !!this.pagination && !!this.frontPagination;
  }

  deleteHideItem() {
    // 首先把isShow为false数据剔除掉
    this.tableCols = this.tableCols.filter((item) => {
      // 如果对象没有 isShow 属性，则默认为 true，保留该对象
      if (!item.hasOwnProperty("isShow")) {
        return true;
      }
      // 如果对象有 isShow 属性，则检查其值是否为 true
      return item.isShow === true;
    });
  }

  sort(sort: { key: string; value: string }) {
    this.currentSortKey = sort && sort.key;
    this.currentSortValue = sort && sort.value;
    this.sortEvent.emit(sort);
  }

  getColSort(col: HdTableColumn): string | null {
    if (!col || !col.canSort || !this.currentSortKey) {
      return null;
    }
    return col.name === this.currentSortKey ? this.currentSortValue : null;
  }

  toggleShowDetail(): void {
    this.showDetail = !this.showDetail;
    this.cdr.markForCheck();
    this.refreshVirtualScrollViewport(true);
  }

  get effectiveVirtualItemSize(): number {
    if (this.virtualItemSize != null && this.virtualItemSize > 0) {
      return this.virtualItemSize;
    }
    return this.measuredVirtualItemSize;
  }

  /**
   * 纵向可用高度扣减：按钮区/合计/分页等固定占位。
   * 必须与 dealScroll / presetScrollBeforeRemount 使用同一套，否则会误判「能放下」而不设 scroll.y。
   */
  private getScrollYMaxOffset(): number {
    return (this.tableTotal ? 180 : 140) + 216;
  }

  /**
   * 当前视口实际展示的行数。
   * 前端分页按 pageIndex/pageSize 切片估算，避免用全量 length 误判需要纵向滚动。
   */
  private getVisibleRowCount(): number {
    const content =
      this.tableData && this.tableData.content ? this.tableData.content : [];
    const total = content.length;
    if (!this.useFrontPagination) {
      return total;
    }
    if (total <= 0) {
      return 0;
    }
    const pageSize =
      Number(this.tablePageSize) > 0 ? Number(this.tablePageSize) : 10;
    const pageIndex =
      Number(this.tablePageIndex) > 0 ? Number(this.tablePageIndex) : 1;
    const start = (pageIndex - 1) * pageSize;
    if (start >= total) {
      return 0;
    }
    return Math.min(pageSize, total - start);
  }

  /** 当前页内容高度是否超出视口（需要表内纵向滚动） */
  get needsVerticalScroll(): boolean {
    const rowCount = this.getVisibleRowCount();
    if (rowCount <= 0) {
      return false;
    }
    const maxOffset = this.getScrollYMaxOffset();
    const estimatedHeight = rowCount * this.effectiveVirtualItemSize;
    if (typeof window !== "undefined") {
      return estimatedHeight > window.innerHeight - maxOffset;
    }
    return rowCount > 100;
  }

  /** 当前页数据能完整展示时不启用虚拟滚动，避免少量数据也出现滚动条 */
  get useVirtualScroll(): boolean {
    if (!this.virtualScroll) {
      return false;
    }
    return this.needsVerticalScroll;
  }

  getRightSticky(col: HdTableColumn): string | null {
    return col.fixed === "right" ? `${col.fixedRightWidth || 0}px` : null;
  }

  getLeftSticky(col: HdTableColumn): string | null {
    return col.fixed === "left" ? `${col.fixedWidth || 0}px` : null;
  }

  trackByRow = (index: number, data: any): string => {
    const key = data && data[this.selectField];
    return key != null ? String(key) : `row-${index}`;
  };

  /** 虚拟滚动按数组下标追踪，避免业务主键 trackBy 导致 CDK 行复用错位 */
  virtualTrackByRow = (index: number): number => index;

  trackByCol = (_index: number, col: HdTableColumn): string => {
    return col.title;
  };

  getInitLocalforage() {
    // 首先获取当前hd-table存储的数据 如果没有，则初始化下当前的数据
    this.localforage
      .getItem(
        "hd-table_" +
          this.userSession.userCode +
          "_" +
          this.localtionTmp +
          "_" +
          this.uuid,
      )
      .then((value: TableCacheOption) => {
        if (value) {
          this.tableCacheOption = value;
          this.normalizeTableCacheOption();
          if (
            this.pagination &&
            this.tableCacheOption.pageSize &&
            this.tableCacheOption.pageSize > 10
          ) {
            this.tablePageSize = this.tableCacheOption.pageSize;
            this.tablePageSizeChange.emit(this.tablePageSize);
          }
        } else {
          this.tableCacheOption = new TableCacheOption();
          this.tableCacheOption.pageSize = this.tablePageSize;
        }
        // 服务端分页才在初始化时抛 pageSizeChangeEvent 触发父查询；前端分页不抛
        if (
          this.pagination &&
          !this.frontPagination &&
          this.isFirstEntrySearchLocal
        ) {
          this.tablePageSizeChangeEvent.emit(this.tablePageSize);
        } else {
          this.isFirstEntrySearchLocal = true;
        }
        this.initTable();
      })
      .catch((err) => {
        this.tableCacheOption = new TableCacheOption();
        this.tableCacheOption.pageSize = this.tablePageSize;
        this.initTable();
      });
  }

  initTable() {
    this.showTable = false;
    if (!this.uuid) {
      throw "hd-table缺失uuid参数，请使用编辑器插件生成并给hd-table赋予uuid属性";
    }
    if (this.judgeRepeatCols()) {
      this.dealCols();
      this.setCols();
      this.dealOperateBtn();
      this.virtualScrollActive = null;
      this.applyTableScrollMode(true);
    }
  }

  /** 虚拟/普通模式切换时重建表格，避免残留滚动容器 */
  applyTableScrollMode(forceRemount = false): void {
    const useVirtual = this.useVirtualScroll;
    const modeChanged =
      this.virtualScrollActive !== null &&
      this.virtualScrollActive !== useVirtual;
    this.virtualScrollActive = useVirtual;

    if (forceRemount || modeChanged) {
      // 必须先写好 scroll.y，再创建 nz-table。
      // ng-zorro 只在 AfterViewInit 绑一次 header/body 的 scroll 同步；
      // 若先以 y=null 创建再改成有 y，表头监听会丢，表现为列头不跟着横滚。
      this.presetScrollBeforeRemount(useVirtual);
      this.showTable = false;
      this.cdr.markForCheck();
      setTimeout(() => {
        this.showTable = true;
        this.cdr.markForCheck();
        setTimeout(() => {
          this.dealScroll();
          this.cdr.markForCheck();
          this.afterTableRender(useVirtual);
        });
      });
      return;
    }

    const prevHasY = !!(this.scroll && this.scroll.y);
    this.dealScroll();
    const nextHasY = !!(this.scroll && this.scroll.y);
    // 运行中 y 从有变无/从无变有时，也必须重建，否则同步监听仍指向旧 DOM
    if (prevHasY !== nextHasY) {
      this.showTable = false;
      this.cdr.markForCheck();
      setTimeout(() => {
        this.showTable = true;
        this.cdr.markForCheck();
        setTimeout(() => {
          this.afterTableRender(useVirtual);
        });
      });
      return;
    }

    this.cdr.markForCheck();
    this.afterTableRender(useVirtual);
  }

  /** 重建前预设 scroll，保证 AfterViewInit 时 header/body 结构已正确 */
  private presetScrollBeforeRemount(useVirtual: boolean): void {
    const maxOffset = this.getScrollYMaxOffset();
    const x = this.scroll ? this.scroll.x : null;
    if (this.virtualScroll && !useVirtual) {
      this.scroll = { x, y: null };
      return;
    }
    this.scroll = {
      x,
      y: `calc(100vh - ${maxOffset}px)`,
    };
  }

  private afterTableRender(useVirtual: boolean): void {
    if (useVirtual) {
      this.refreshVirtualScrollViewport(true);
      return;
    }
    if (this.virtualScroll) {
      this.measureVirtualItemSize(true);
      // 实测行高后可能从「能放下」变为「超出」，需切换滚动模式
      if (this.useVirtualScroll) {
        this.applyTableScrollMode(false);
        return;
      }
    }
    setTimeout(() => {
      this.syncHorizontalScroll();
      this.flushResetTableBodyScrollTop();
    });
  }

  refreshVirtualScrollViewport(forceMeasure = false): void {
    if (!this.useVirtualScroll) {
      if (forceMeasure) {
        this.measureVirtualItemSize(forceMeasure);
        this.dealScroll();
        this.cdr.markForCheck();
      }
      this.flushResetTableBodyScrollTop();
      return;
    }
    setTimeout(() => {
      const viewport =
        this.nzTableComponent && this.nzTableComponent.cdkVirtualScrollViewport;
      if (!viewport) {
        this.syncHorizontalScroll();
        this.flushResetTableBodyScrollTop();
        return;
      }
      const measured = this.measureVirtualItemSize(forceMeasure);
      if (measured) {
        this.dealScroll();
        this.cdr.markForCheck();
        viewport.checkViewportSize();
        setTimeout(() => {
          this.measureVirtualItemSize(forceMeasure);
          this.syncHorizontalScroll();
          viewport.checkViewportSize();
          this.flushResetTableBodyScrollTop();
        });
      } else {
        viewport.checkViewportSize();
        this.syncHorizontalScroll();
        this.flushResetTableBodyScrollTop();
      }
    });
  }

  /** 数据刷新后将表体纵向滚动复位到顶部 */
  private resetTableBodyScrollTop(): void {
    if (!this.nzTableComponent) {
      return;
    }
    const nzTable = this.nzTableComponent as any;
    const viewport = this.nzTableComponent.cdkVirtualScrollViewport;
    if (viewport) {
      if (typeof (viewport as any).scrollToOffset === "function") {
        (viewport as any).scrollToOffset(0);
      }
      if (typeof (viewport as any).scrollToIndex === "function") {
        (viewport as any).scrollToIndex(0);
      }
      const viewportEl =
        viewport.elementRef &&
        (viewport.elementRef.nativeElement as HTMLElement);
      if (viewportEl) {
        viewportEl.scrollTop = 0;
      }
    }
    const bodyCandidates = [
      nzTable.mixTableBodyNativeElement,
      nzTable.tableBodyNativeElement,
      nzTable.tableBodyElement && nzTable.tableBodyElement.nativeElement,
    ];
    bodyCandidates.forEach((el: HTMLElement) => {
      if (el) {
        el.scrollTop = 0;
      }
    });
    const tableMain =
      nzTable.tableMainElement &&
      (nzTable.tableMainElement.nativeElement as HTMLElement);
    if (!tableMain) {
      return;
    }
    const nodes = tableMain.querySelectorAll(
      ".ant-table-body, cdk-virtual-scroll-viewport",
    );
    Array.prototype.forEach.call(nodes, (el: HTMLElement) => {
      el.scrollTop = 0;
    });
  }

  /**
   * 数据更新后多次尝试复位。
   * ng-zorro 8 + CDK 虚拟滚动会在数据刷新后异步改写 scrollTop，单次复位经常被覆盖。
   */
  private scheduleResetTableBodyScrollTop(): void {
    // 多次尝试：覆盖 nz-table / CDK 虚拟滚动异步改写 scrollTop
    const delays = [0, 50, 100];
    delays.forEach((ms, index) => {
      setTimeout(() => {
        this.resetTableBodyScrollTop();
        if (index === delays.length - 1) {
          this.pendingResetScrollTop = false;
        }
      }, ms);
    });
  }

  private flushResetTableBodyScrollTop(): void {
    if (!this.pendingResetScrollTop) {
      return;
    }
    this.resetTableBodyScrollTop();
  }

  /** 未手动传 virtualItemSize 时，从已渲染行测量真实高度 */
  measureVirtualItemSize(force = false): boolean {
    if (this.virtualItemSize != null && this.virtualItemSize > 0 && !force) {
      return false;
    }
    const viewport =
      this.nzTableComponent && this.nzTableComponent.cdkVirtualScrollViewport;
    const tableBody =
      this.nzTableComponent &&
      (this.nzTableComponent.tableBodyNativeElement as HTMLElement);
    const row =
      (viewport &&
        ((viewport.elementRef.nativeElement as HTMLElement).querySelector(
          "tr.hd-table-virtual-row",
        ) as HTMLElement)) ||
      (tableBody && (tableBody.querySelector("tbody tr") as HTMLElement));
    if (!row || row.offsetHeight <= 0) {
      return false;
    }
    const height = row.offsetHeight;
    if (height === this.measuredVirtualItemSize) {
      return false;
    }
    this.measuredVirtualItemSize = height;
    return true;
  }

  // 设置列点击取消
  cancelDropdown(): void {
    this.isDropdownVisible = false;
    this.hideListNodes = JSON.parse(JSON.stringify(this.cancelHideListNodes));
    this.nowListNodes = JSON.parse(JSON.stringify(this.cancelNowListNodes));
    this.cdr.markForCheck();
  }

  // 点击触发设置列
  confirmDropdown(): void {
    // 临时存放下，取消的时候恢复原来的状态   深拷贝下对象数组
    this.cancelHideListNodes = JSON.parse(JSON.stringify(this.hideListNodes));
    this.cancelNowListNodes = JSON.parse(JSON.stringify(this.nowListNodes));
    this.isDropdownVisible = true;
    this.cdr.markForCheck();
  }

  submitGrids() {
    this.tableCacheOption.cols = [];
    this.nowListNodes.forEach((item) => {
      this.tableCacheOption.cols.push(item.title);
    });
    this.saveTableCacheOption();
    this.initTable();
    this.isDropdownVisible = false;
    this.cdr.markForCheck();
  }

  // 从缓存设置列
  setCols() {
    this.showListNodes = false;
    this.nowListNodes = [];
    this.hideListNodes = [];
    if (this.hasColsCache()) {
      let { notIncols, incols } = this.tableColsCache.reduce(
        (acc, item) => {
          if (this.tableCacheOption.cols.includes(item.title)) {
            acc.incols.push(item);
          } else {
            acc.notIncols.push(item);
          }
          return acc;
        },
        { notIncols: [], incols: [] },
      );
      incols.sort((a, b) => {
        return (
          this.tableCacheOption.cols.indexOf(a.title) -
          this.tableCacheOption.cols.indexOf(b.title)
        );
      });
      this.tableCols = incols.concat(notIncols);
    }

    this.tableCols.forEach((element, index) => {
      if (this.hasColsCache()) {
        element.isShow = this.tableCacheOption.cols.includes(element.title)
          ? true
          : false;
        if (element.isShow) {
          this.nowListNodes.push({
            title: element.title,
            key: element.title,
            disabled: element.fixed ? true : false,
            // selectable: false,
            checked: this.tableCacheOption.cols.includes(element.title)
              ? true
              : false,
          });
        } else {
          this.hideListNodes.push({
            title: element.title,
            key: element.title,
            disabled: element.fixed ? true : false,
            // selectable: false,
            checked: this.tableCacheOption.cols.includes(element.title)
              ? true
              : false,
          });
        }
      } else {
        element.isShow = true;
        this.nowListNodes.push({
          title: element.title,
          key: element.title,
          checked: true,
          // selectable: false,
          disabled: element.fixed ? true : false,
        });
      }
    });

    // 调整列宽为缓存宽度
    if (
      this.tableCacheOption &&
      this.tableCacheOption.colWidths &&
      this.tableCacheOption.colWidths.size !== 0
    ) {
      this.tableCols.forEach((col) => {
        if (this.tableCacheOption.colWidths.has(col.title)) {
          col.width = this.tableCacheOption.colWidths.get(col.title);
        }
      });
    }

    this.dealCols();
    setTimeout(() => {
      this.showListNodes = true;
    }, 0);
  }

  // 拖拽操作
  beforeDrop = (arg: NzFormatBeforeDropEvent): Observable<boolean> => {
    if (
      arg.node.origin.disabled ||
      !arg.dragNode.origin.checked ||
      arg.pos === 0
    ) {
      return of(false);
    } else {
      let node: TreeGrid = new TreeGrid();
      node.checked = arg.dragNode.origin.checked;
      node.disabled = arg.dragNode.origin.disabled;
      node.expanded = arg.dragNode.origin.expanded;
      node.isLeaf = arg.dragNode.origin.isLeaf;
      node.key = arg.dragNode.origin.key;
      node.selectable = arg.dragNode.origin.selectable;
      node.title = arg.dragNode.origin.title;
      // 拖拽元素下标
      let dragNodeIndex = this.nowListNodes.findIndex((item) => {
        return item.title == arg.dragNode.origin.title;
      });
      // 目标位置的下标
      let nodeIndex =
        this.nowListNodes.findIndex((item) => {
          return item.title == arg.node.origin.title;
        }) + (arg.pos === -1 ? 0 : arg.pos);
      this.nowListNodes.splice(nodeIndex, 0, node);
      this.nowListNodes.splice(
        nodeIndex >= dragNodeIndex ? dragNodeIndex : dragNodeIndex + 1,
        1,
      );
      return of(true).pipe(delay(100));
    }
  };

  moveElementNearby(arr, elementToMoveTitle, targetElementTitle, pos) {
    const tmpArray = JSON.parse(JSON.stringify(arr));
    const targetIndex = tmpArray.findIndex(
      (item) => item.title === targetElementTitle,
    );
    const elementIndex = tmpArray.findIndex(
      (item) => item.title === elementToMoveTitle,
    );
    const newIndex = pos < 0 ? targetIndex + pos : targetIndex;
    // 移除目标元素，并插入到新的位置
    const removedElement = tmpArray.splice(elementIndex, 1);
    tmpArray.splice(newIndex + 1, 0, removedElement[0]);
    return tmpArray;
  }

  // 勾选操作
  checkAction(event: NzFormatEmitEvent): void {
    // 勾选只有在hideListNodes,取消勾选只有在nowListNodes
    if (event.node.origin.checked) {
      let node: TreeGrid = new TreeGrid();
      node = this.hideListNodes.find((item) => {
        return item.title === event.node.origin.title;
      });
      node.checked = true;
      // 找到第一个fixed属性为right的title，找到插入元素的位置
      let title = null;
      for (let i = this.tableColsCache.length - 1; i >= 0; i--) {
        if (this.tableColsCache[i].fixed === "right") {
          title = this.tableColsCache[i].title;
          break;
        }
      }
      let temporaryNodeList = this.nowListNodes.slice(0);
      if (!title) {
        temporaryNodeList.push(node);
      } else {
        const index = this.nowListNodes.findIndex(
          (node) => node.title === title,
        );
        temporaryNodeList.splice(index, 0, node);
      }
      this.nowListNodes = temporaryNodeList;
      this.hideListNodes = this.hideListNodes.filter((item) => {
        return item.title !== event.node.origin.title;
      });
    } else {
      // if (this.hideListNodes.length === 0 && this.tableCacheOption && this.tableCacheOption.cols) {
      //   this.hideListNodes = this.getHideListNodes();
      // }
      let temporaryNodeList = this.hideListNodes.slice(0);
      this.nowListNodes.forEach((item) => {
        if (item.title === event.node.origin.title) {
          const innerItem = JSON.parse(JSON.stringify(item));
          innerItem.checked = false;
          temporaryNodeList.push(innerItem);
        }
      });
      this.hideListNodes = temporaryNodeList;

      // 为了防止未选择的数组顺序因为push方法而改变，通过初始数据获取显示的字段列表
      this.nowListNodes = this.nowListNodes.filter((item) => {
        return item.title !== event.node.origin.title;
      });
    }
    this.cdr.markForCheck();
  }

  // 防止未选择的数组顺序因为push方法而改变，从初始数据获取隐藏未显示的字段列表
  getHideListNodes(): Array<TreeGrid> {
    let temporaryNodeList: Array<TreeGrid> = [];
    // 从tableColsCache里面找没有在storage里面出现的字段,组成hideList
    this.tableColsCache.forEach((item) => {
      if (!this.tableCacheOption.cols.includes(item.title)) {
        let nodeItem: TreeGrid = new TreeGrid();
        nodeItem.title = item.title;
        nodeItem.key = item.title;
        nodeItem.disabled = item.fixed ? true : false;
        nodeItem.checked = false;
        temporaryNodeList.push(nodeItem);
      }
    });
    return temporaryNodeList;
  }

  dealCols() {
    if (!this.tableCols[0].minWidth) {
      this.tableCols.forEach((item) => {
        const span = document.createElement("span");
        span.style.visibility = "hidden";
        span.style.position = "absolute";
        span.style.whiteSpace = "nowrap";
        span.style.fontSize = "14px";
        span.style.display = "inline-block"; // 将样式修改为 inline-block
        span.innerText = item.title;
        document.body.appendChild(span);
        item.minWidth = span.offsetWidth + 16;
        span.style.display = "none";
        document.body.removeChild(span);
      });
    }
    // 处理左右吸附的数据在数组中的位置
    const leftFixedCols = this.tableCols.filter((col) => col.fixed === "left");
    const rightFixedCols = this.tableCols.filter(
      (col) => col.fixed === "right",
    );
    const normalCols = this.tableCols.filter((col) => !col.fixed);
    const resultCols = leftFixedCols.concat(normalCols).concat(rightFixedCols);
    this.tableCols = resultCols;
    if (!this.tableColsCache || this.tableColsCache.length === 0) {
      // 缓存一下表格的数据
      this.tableColsCache = [...this.tableCols];
    }
  }

  normalizeTableCacheOption() {
    if (!this.tableCacheOption.colWidths) {
      this.tableCacheOption.colWidths = new Map<string, number>();
    } else if (!(this.tableCacheOption.colWidths instanceof Map)) {
      const colWidths = new Map<string, number>();
      Object.keys(this.tableCacheOption.colWidths).forEach((key) => {
        colWidths.set(key, (this.tableCacheOption.colWidths as any)[key]);
      });
      this.tableCacheOption.colWidths = colWidths;
    }
  }

  private hasColsCache(): boolean {
    return !!(
      this.tableCacheOption &&
      this.tableCacheOption.cols &&
      this.tableCacheOption.cols.length > 0
    );
  }

  saveTableCacheOption() {
    this.localforage.setItem(
      "hd-table_" +
        this.userSession.userCode +
        "_" +
        this.localtionTmp +
        "_" +
        this.uuid,
      this.tableCacheOption,
    );
  }

  judgeRepeatCols() {
    for (let i = 0; i < this.tableCols.length; i++) {
      for (let j = i + 1; j < this.tableCols.length; j++) {
        if (this.tableCols[i].title === this.tableCols[j].title) {
          throw `hd-table组件中列名 ${this.tableCols[i].title} 重复`;
        }
      }
    }
    return true;
  }

  onResize({ width }: NzResizeEvent, col: HdTableColumn): void {
    this.normalizeTableCacheOption();
    let tempWidth = 0;
    if (width > col.minWidth) {
      tempWidth = width;
    } else {
      tempWidth = col.minWidth;
    }
    this.tableCacheOption.colWidths.set(col.title, tempWidth);
    this.saveTableCacheOption();
    this.tableCols = this.tableCols.map((e) =>
      e.title === col.title ? { ...e, width: tempWidth } : e,
    );
    this.dealScroll();
    this.cdr.markForCheck();
  }

  dealOperateBtn() {
    let operateCol = this.tableCols.find((col) => col.title === "操作") || null;
    if (operateCol) {
      let textStr = "";
      operateCol.btnList.forEach((btn) => {
        if (!btn.isRepeat) {
          textStr += typeof btn.name === "function" ? "操作" : btn.name;
        }
      });

      const span = document.createElement("a");
      span.style.visibility = "hidden";
      span.style.position = "absolute";
      span.style.whiteSpace = "nowrap";
      span.style.fontSize = "14px";
      span.style.display = "inline-block"; // 将样式修改为 inline-block
      span.innerText = textStr;
      document.body.appendChild(span);
      operateCol.width =
        span.offsetWidth +
        (operateCol.btnList.filter((item) => !item.isRepeat).length - 1) * 4 +
        16;
      span.style.display = "none";
      document.body.removeChild(span);
    }
  }

  triggerEvent(fn: any, event: any) {
    if (fn) {
      fn(event);
    }
  }

  needShowConfirm(btn: OperateBtn, data: any): boolean {
    if (typeof btn.showConfirm === "function") {
      return btn.showConfirm(data);
    }
    return !!btn.showConfirm;
  }

  getBtnName(btn: OperateBtn, data: any): string {
    if (typeof btn.name === "function") {
      return btn.name(data) || "";
    }
    return btn.name != null ? String(btn.name) : "";
  }

  isDangerBtn(btn: OperateBtn, data: any): boolean {
    return this.getBtnName(btn, data) === "删除";
  }

  /** 虚拟滚动开启时使用视口最大高度 */
  private getVirtualScrollY(maxOffset: number): string {
    return `calc(100vh - ${maxOffset}px)`;
  }

  private hasTableData(): boolean {
    return !!(
      this.tableData &&
      this.tableData.content &&
      this.tableData.content.length
    );
  }

  /** 列总宽超出外层容器才启用横向 scroll（不能用 table 自身宽度，会被 scroll.x 撑宽） */
  private resolveScrollX(colWidth: number): string | null {
    let width = colWidth;
    if (this.nzTableComponent) {
      const measured = measureTableColWidth(this.nzTableComponent);
      if (measured > width) {
        width = measured;
      }
    }
    const autoScroll = resolveAutoTableScroll(
      this.nzTableComponent,
      this.hasTableData(),
      width,
    );
    return autoScroll ? autoScroll.x : null;
  }

  /** 表格渲染后按实际容器宽度校正横向 scroll（只改 x，避免触发表头结构变化） */
  private syncHorizontalScroll(): void {
    const scrollX = this.resolveScrollX(this.tableColWidthTotal);
    const currentY = this.scroll ? this.scroll.y : null;
    if (
      this.scroll &&
      this.scroll.x === scrollX &&
      this.scroll.y === currentY
    ) {
      return;
    }
    // 保持 y 不变，防止运行中拆/合 header 导致横向同步失效
    this.scroll = { x: scrollX, y: currentY };
    this.cdr.markForCheck();
    setTimeout(() => this.syncHeaderBodyScrollLeft());
  }

  /** 手动把表体横向滚动同步到表头（兜底 ng-zorro 监听丢失的情况） */
  private syncHeaderBodyScrollLeft(): void {
    if (!this.nzTableComponent || !this.scroll || !this.scroll.x) {
      return;
    }
    const header = (this.nzTableComponent as any).tableHeaderNativeElement as
      | HTMLElement
      | null;
    const body = (this.nzTableComponent as any).mixTableBodyNativeElement as
      | HTMLElement
      | null;
    if (!header || !body) {
      return;
    }
    if (header.scrollLeft !== body.scrollLeft) {
      header.scrollLeft = body.scrollLeft;
    }
  }

  dealScroll() {
    let colWidth = 0;
    if (this.showSelected) {
      colWidth += 40;
    }
    this.tableCols.forEach((item) => {
      if (!item.width) {
        item.width = ColWidth.fixColWidth;
      }
      if (item.isShow) {
        item.fixedWidth = colWidth;
        colWidth += item.width;
      }
    });

    // 右侧固定列：从右往左累计偏移，避免多列都 right:0 互相遮挡
    let rightOffset = 0;
    for (let i = this.tableCols.length - 1; i >= 0; i--) {
      const item = this.tableCols[i];
      if (!item.isShow) {
        continue;
      }
      if (item.fixed === "right") {
        item.fixedRightWidth = rightOffset;
        rightOffset += item.width;
      } else {
        item.fixedRightWidth = 0;
      }
    }

    this.tableColWidthTotal = colWidth;
    const maxOffset = this.getScrollYMaxOffset();
    const useVirtual = this.useVirtualScroll;
    const scrollX = this.resolveScrollX(colWidth);

    if (this.virtualScroll && !useVirtual) {
      this.scroll = {
        x: scrollX,
        y: null,
      };
      return;
    }

    if (!this.virtualScroll) {
      this.scroll = {
        x: scrollX,
        y: `calc(100vh - ${maxOffset}px)`,
      };
      return;
    }

    this.scroll = {
      x: scrollX,
      y: this.getVirtualScrollY(maxOffset),
    };
  }

  // 表格勾选逻辑
  currentPageDataChange($event: any): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
    if (!this.isCrossPageSelectLocal) {
      this.resetStatus();
    }
    this.cdr.markForCheck();
  }

  search(reset: boolean) {
    if (!this.pagination) {
      return;
    }
    // 前端分页：只同步页码/条数，不触发父组件查询
    if (this.frontPagination) {
      if (reset) {
        this.tablePageIndex = 1;
        this.tablePageSizeChange.emit(this.tablePageSize);
      } else {
        this.tablePageIndexChange.emit(this.tablePageIndex);
      }
      this.tableCacheOption.pageSize = this.tablePageSize;
      this.saveTableCacheOption();
      // 按当前页行数重算是否需要 scroll.y（末页数据少时去掉固定高度，避免留白）
      this.pendingResetScrollTop = true;
      this.applyTableScrollMode(false);
      this.scheduleResetTableBodyScrollTop();
      this.cdr.markForCheck();
      return;
    }
    this.tableCacheOption.pageSize = this.tablePageSize;
    this.saveTableCacheOption();
    if (reset) {
      this.tablePageSizeChange.emit(this.tablePageSize);
      this.tablePageSizeChangeEvent.emit(this.tablePageSize);
    } else {
      this.tablePageIndexChange.emit(this.tablePageIndex);
      // 触发父组件查询事件
      this.tableSearchEvent.emit(reset);
    }
  }

  /** 底部「共 n 条」：非分页/前端分页用 content.length，服务端分页用 totalElements */
  getTableTotalCount(): number {
    if (!this.tableData) {
      return 0;
    }
    if (!this.pagination || this.frontPagination) {
      return this.tableData.content ? this.tableData.content.length : 0;
    }
    return this.tableData.totalElements != null
      ? this.tableData.totalElements
      : 0;
  }

  resetStatus() {
    this.isAllDisplayDataChecked = false;
    this.isIndeterminate = false;
    // 先显式置 false，避免 nz-checkbox 内部状态与 mapOfCheckedId 不同步（虚拟滚动复用行时常见）
    Object.keys(this.mapOfCheckList).forEach((key) => {
      this.mapOfCheckedId[key] = false;
    });
    this.listOfDisplayData.forEach((item) => {
      const key = item[this.selectField];
      if (key != null) {
        this.mapOfCheckedId[key] = false;
      }
    });
    this.mapOfCheckedId = {};
    this.mapOfCheckList = {};
    this.selectEvent.emit([]);
    this.cdr.markForCheck();
  }

  refreshStatus(event: boolean = false, data: any = null): void {
    if (data) {
      // 禁用行不允许勾选；取消勾选仍允许（例如数据变更前已勾选）
      if (event && this.isSelectDisabled(data)) {
        this.cdr.markForCheck();
        return;
      }
      this.mapOfCheckedId[data[this.selectField]] = event;
      if (event) {
        !this.mapOfCheckList[data[this.selectField]] &&
          (this.mapOfCheckList[data[this.selectField]] = data);
      } else {
        this.mapOfCheckList[data[this.selectField]] &&
          delete this.mapOfCheckList[data[this.selectField]];
      }
    }
    const selectableList = this.listOfDisplayData.filter(
      (item) => !this.isSelectDisabled(item),
    );
    this.isAllDisplayDataChecked =
      selectableList.length > 0 &&
      selectableList.every((item) => this.mapOfCheckedId[item[this.selectField]]);
    this.isIndeterminate =
      selectableList.some(
        (item) => this.mapOfCheckedId[item[this.selectField]],
      ) && !this.isAllDisplayDataChecked;
    // 触发select事件
    if (this.selectEvent) {
      const selectedList: Array<any> = Object.values(this.mapOfCheckList);
      this.selectEvent.emit(selectedList);
    }
    // 如果数据为空，则清空勾选标识
    if (this.tableData.content.length === 0) {
      this.isAllDisplayDataChecked = false;
    }
    this.cdr.markForCheck();
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach((item) => {
      // 全选/取消全选均跳过禁用行（禁用行保持原勾选状态）
      if (this.isSelectDisabled(item)) {
        return;
      }
      if (value) {
        !this.mapOfCheckList[item[this.selectField]] &&
          (this.mapOfCheckList[item[this.selectField]] = item);
      } else {
        this.mapOfCheckList[item[this.selectField]] &&
          delete this.mapOfCheckList[item[this.selectField]];
      }

      this.mapOfCheckedId[item[this.selectField]] = value;
    });
    this.refreshStatus();
    this.cdr.markForCheck();
  }

  /** 当前行是否禁用勾选 */
  isSelectDisabled(data: any): boolean {
    return !!(
      this.selectDisabledField &&
      data &&
      data[this.selectDisabledField] === true
    );
  }

  /** 当前行是否失效 */
  isInvalidRow(data: any): boolean {
    return !!(
      this.rowInvalidField &&
      data &&
      data[this.rowInvalidField] === true
    );
  }

  /**
   * 列文字颜色：color 为函数时按行计算（用于某一行某一列标红），否则整列同色。
   */
  resolveCellColor(col: HdTableColumn, data: any): string {
    if (!col || col.color == null || col.color === "") {
      return null;
    }
    if (typeof col.color === "function") {
      const value = col.color(data);
      return value || null;
    }
    return col.color;
  }

  /** 可点击单元格颜色：空值固定灰，否则按列 color */
  getLinkCellColor(col: HdTableColumn, data: any, isEmpty: boolean): string {
    if (isEmpty) {
      return "#2A3634";
    }
    return this.resolveCellColor(col, data);
  }

  /** 普通文本单元格颜色：失效行统一灰，否则用列配置 color */
  getPlainCellColor(col: HdTableColumn, data: any): string {
    if (this.isInvalidRow(data)) {
      return "#868A9C";
    }
    return this.resolveCellColor(col, data);
  }

  judgeColEmpty(str: any) {
    if (str || str === 0) {
      return str;
    } else {
      return "<空>";
    }
  }

  getStateField(col: HdTableColumn): string {
    if (col.isState) {
      return col.name as string;
    }
    return col.stateField || "state";
  }

  /** 字段值后是否展示竖线行号 */
  hasRowNo(col: HdTableColumn): boolean {
    return !!(col && (col.rowNo === true || (typeof col.rowNo === "string" && col.rowNo)));
  }

  /**
   * 行号文案。rowNo 为字段名时取行数据；为 true 时按当前页序号（跨页连续，从 1 开始）。
   */
  getRowNoText(col: HdTableColumn, data: any, index: number): string {
    if (!this.hasRowNo(col)) {
      return "";
    }
    if (typeof col.rowNo === "string") {
      const value = data ? data[col.rowNo] : null;
      if (value == null || value === "") {
        return "";
      }
      return String(value);
    }
    const page = Number(this.tablePageIndex) > 0 ? Number(this.tablePageIndex) : 1;
    const size = Number(this.tablePageSize) > 0 ? Number(this.tablePageSize) : 0;
    const rowIndex = Number(index) >= 0 ? Number(index) : 0;
    return String((page - 1) * size + rowIndex + 1);
  }

  /** 表头「配送单号 | 行」拆成短竖线，避免字符 | 拉满行高 */
  getTitleParts(col: HdTableColumn): Array<string> {
    if (!this.hasRowNo(col) || !col || !col.title || String(col.title).indexOf("|") < 0) {
      return null;
    }
    const raw = String(col.title).split("|");
    if (raw.length < 2) {
      return null;
    }
    return [raw[0].trim(), raw.slice(1).join("|").trim()];
  }

  /** 是否显示编辑笔图标 */
  isEditable(col: HdTableColumn, data: any): boolean {
    if (!col || col.editable == null || col.editable === false) {
      return false;
    }
    if (typeof col.editable === "function") {
      return !!col.editable(data);
    }
    return !!col.editable;
  }

  /** 点击编辑笔，回调父组件传入的 edit */
  onEditClick(event: Event, col: HdTableColumn, data: any): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.triggerEvent(col.edit || null, data);
  }
}
